/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import type { AxiosResponse } from 'axios';
import {
  ClickAwayListener,
  Fade,
  Grid, IconButton, Paper, Popper,
} from '@mui/material';
import StradaSearch from 'admin/buildingSection/budget-calendar/components/StradaSearch';
import { useNavigate } from 'react-router-dom';
import CustomTable from 'shared-components/tables/CustomTable';
import type { IDataObject } from 'formsTypes';
import type { Cell } from 'react-table';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import type { RootState } from 'mainStore';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import BuildingFilter from 'admin/buildingSection/budget-calendar/components/BuildingFilter';
import CustomLoader from 'shared-components/components/CustomLoader';
import type { RFPListing } from './types';
import ViewActivity from './ViewActivity';

function RFPContent(): JSX.Element {
  const [search, setSearch] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [showActivity, setShowActivity] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<RFPListing>();
  const [buildingFilter, setBuildingFilter] = useState<number[]>([]);
  const [startLoader, setStartLoader] = useState<boolean>(true);
  const currentWorkspace = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );
  const { data: rfpData = [], isIdle, isLoading } = useQuery(['get/rfp-listing', search, buildingFilter], async () => axios({
    url: `/api/rfp/?workspace=${currentWorkspace.id}`,
    method: 'GET',
    params: {
      search,
      property: buildingFilter,
    },
  }), {
    onSuccess: () => {
      setStartLoader(false);
    },
    select: (res: AxiosResponse<RFPListing[]>) => res.data,
  });

  const onViewActivityClick = (data: RFPListing): void => {
    // const info = rfpData.filter((rfp: RFPListing) => rfp.id === data.id);
    setSelectedData(data);
    setShowActivity(true);
  };

  const handleBack = (): void => {
    setShowActivity(false);
  };

  const { mutate: deleteRFP } = useMutation(async (id: number | string | undefined) => axios({
    url: `api/rfp/${id}/`,
    method: 'DELETE',
  }), {
    onSuccess: async () => {
      enqueueSnackbar('RFP Deleted Successfully');
      await queryClient.invalidateQueries('get/rfp-listing')
        .then();
    },
    onError: (): void => {
      enqueueSnackbar('Error in Deleting RFP');
    },
  });

  const columns = useMemo(() => [
    {
      Header: 'Event',
      accessor: 'event_name',
      width: '30%',
    },
    {
      Header: 'Property',
      accessor: 'property',
      width: '30%',
      Cell: (cell: Cell<IDataObject>): JSX.Element => {
        const { value } = cell;
        return (
          <div>
            {value.address}
          </div>
        );
      },
    },
    {
      Header: 'Budgeted',
      accessor: 'budget',
      width: '20%',
      Cell: (cell: Cell<IDataObject>): JSX.Element => {
        const { value } = cell;
        const newVal: number | null = value;
        return (
          <div>
            {newVal !== null ? ` $${newVal.toLocaleString()}` : ''}
          </div>
        );
      },
    },

    {
      Header: 'Date',
      accessor: 'created_at',
      width: '20%',
      Cell: (cell: Cell<IDataObject>): JSX.Element => {
        const { value } = cell;
        const newVal: string | null = value;
        return (
          <div>
            {newVal !== null ? moment(newVal).format('MM/DD/YYYY') : ''}
          </div>
        );
      },
    },
    {
      Header: '',
      accessor: 'account_new',
      width: '5%',
      Cell: (cell: Cell<IDataObject>): JSX.Element => {
        const { row } = cell;
        const { original } = row;
        return (
          <div style={{ textAlign: 'right' }}>
            <PopupState variant='popper' popupId='demo-popup-popper'>
              {(popupState): JSX.Element => (
                <div>
                  <IconButton {...bindToggle(popupState)}>
                    <MoreHorizIcon fontSize='small' />
                  </IconButton>
                  <Popper
                    {...bindPopper(popupState)}
                    transition
                  >
                    {({ TransitionProps }): JSX.Element => (
                      <ClickAwayListener onClickAway={(): void => { popupState.close(); }}>
                        <Fade {...TransitionProps} timeout={350}>
                          <Paper className='rfp-popover'>
                            <div
                              className='chart-btn'
                              onClick={(): void => {
                                // onViewProposalClick(original);
                                navigate(`/workspace/rfps/${original.id}`);
                                popupState.close();
                              }}
                              aria-hidden='true'
                            >
                              View Proposals
                            </div>
                            <div
                              className='chart-btn'
                              onClick={(): void => { onViewActivityClick(original); popupState.close(); }}
                              aria-hidden='true'
                            >
                              View Activity
                            </div>
                            <div
                              className='chart-btn'
                              onClick={(): void => { navigate(`/workspace/event-tracker?eventId=${original.event}`); popupState.close(); }}
                              aria-hidden='true'
                            >
                              Go to Event
                            </div>
                            <div
                              className='chart-btn'
                              onClick={(): void => { deleteRFP(original.id); popupState.close(); }}
                              aria-hidden='true'
                            >
                              Delete
                            </div>
                          </Paper>
                        </Fade>
                      </ClickAwayListener>
                    )}
                  </Popper>
                </div>
              )}
            </PopupState>

          </div>
        );
      },
    },
  ], []);

  useEffect(() => {
    setStartLoader(true);
  }, [search, buildingFilter]);

  return (
    <>
      {rfpData.length === 0 && !isIdle && search.length === 0 && buildingFilter.length === 0 ? (
        <div className='empty-array-wrapper-1'>
          {startLoader
            ? <CustomLoader />
            : (
              <p>No RFPs </p>
            )}
        </div>
      ) : ''}

      {!showActivity && (rfpData.length > 0 || search.length !== 0 || buildingFilter.length !== 0) && (
        <div
          style={{
            display: 'flex', width: '100%', margin: '42px 1.5rem 1.5rem 1.5rem',
          }}
          className='Main-purchase-orders'
        >
          <div className='purchases'>
            <Grid container mt={2} spacing={3} className='search-field-wrapper'>
              <Grid item sm={6}>
                <p className='search-field-typo search-field-rfp-header' style={{ color: '#212121DE' }}>RFPs</p>
              </Grid>
              <Grid item sm={6} className='search-field-rfp'>

                <div className='d-flex align-items-center'>
                  <div className='px-2'>
                    <BuildingFilter
                      buildingFilter={buildingFilter}
                      setBuildingFilter={setBuildingFilter}
                    />
                  </div>
                  <div className='search-wrapper'>
                    <StradaSearch
                      value={search}
                      setSearch={setSearch}
                      placeholder='Search'
                    />
                  </div>

                </div>

              </Grid>
            </Grid>
            <div className='table-divider' style={{ marginTop: '50px' }}>
              <CustomTable {...{ columns, data: rfpData }} />
              {(search.length !== 0 || buildingFilter.length !== 0) && rfpData.length === 0 && !isLoading ? (
                <div className='empty-array-wrapper-1' style={{ marginTop: '11rem' }}>
                  <p>No RFPs </p>
                </div>
              ) : ''}
              {startLoader ? (
                <div className='d-flex justify-content-center mt-5'>
                  <CustomLoader />
                </div>
              ) : ''}
            </div>
          </div>
        </div>
      )}
      {showActivity && <ViewActivity rfpData={selectedData} handleBack={handleBack} />}
    </>
  );
}

export default RFPContent;
